import { Loading } from "@podtrac/common/components/Loading";
import React, { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { Route, Routes } from "react-router-dom";
import AddShow from "../account/AddShow";
import Checkout from "../account/Checkout";
import EpisodeDetail from "../account/EpisodeDetail";
import Upgrade from "../account/Upgrade";
import UpgradeAccount from "../account/UpgradeAccount";
import AccountInfo from "../account/settings/AccountInfo";
import { AccountSettingsLayout } from "../account/settings/AccountSettingsLayout";
import ExportStats from "../account/settings/ExportStats";
import FeedScan from "../account/settings/FeedScan";
import Shows from "../account/settings/Shows";
import Survey from "../account/settings/Survey";
import Users from "../account/settings/Users";
import YouTubeChannels from "../account/settings/YouTube";
import Campaigns from "../advertising/Campaigns";
import { useAccounts } from "../api/accounts";
import KeyMetrics from "../key-metrics";
import Layout from "../layout/Layout";
import { LinksLayout } from "../links/links-layout";
import Rankings from "../rankings/Rankings";
import ShowRankingsPodtrac from "../rankings/show/show-rankings-podtrac";
import Audience from "../reports/Audience";
import Demographics from "../reports/Demographics";
import Downloads from "../reports/Downloads";
import EpisodeComparison from "../reports/EpisodeComparison";
import MeasurementReport from "../reports/MeasurementReports/components/MeasurementReport";
import Error from "../shared/Error";
import Help from "../shared/Help";
import OfficeHours from "../shared/OfficeHours";
import Sad from "../shared/Sad";
import ShowDetails from "../show-details";
import FeedMirror from "../show/FeedMirror";
import FeedSettings from "../show/Feeds";
import MeasurementSettings from "../show/Measurement";
import ShowInfo from "../show/ShowInfo";
import { ShowSettingsLayout } from "../show/ShowSettingsLayout";
import YouTubeShowSettings from "../show/YouTube";
import EditProfile from "../user/EditProfile";
import LeftNav from "./LeftNav";
import SelectAccount from "./SelectAccount";
import TopNav from "./TopNav";
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { LinksRoutes } from "../links/links-routes";
import { ShowRankingsRoutes } from "../rankings/show/show-rankings-routes";

export const filterAtom = atom("");
export const sortAtom = atomWithStorage("shows-sort", "T");
export const viewAtom = atomWithStorage("shows-view", "card");

export default function Dashboard() {
    const dispatch = useDispatch(),
        { isSuccess, isError, error } = useAccounts();
    const filter = useState("");
    const sort = useState("T");
    return isSuccess ? (
        <Routes>
            <Route
                path="*"
                element={<Layout top={<TopNav />} left={<LeftNav />} />}
            >
                <Route index element={<SelectAccount />} />
                <Route path=":accountID/*">
                    <Route index element={<KeyMetrics />} />
                    <Route path="advertising" element={<Campaigns />} />
                    <Route path="checkout" element={<Checkout />} />
                    <Route path="episode-detail" element={<EpisodeDetail />} />
                    <Route path="add-show" element={<AddShow />} />
                    <Route
                        path="settings/*"
                        element={<AccountSettingsLayout />}
                    >
                        <Route index element={<AccountInfo />} />
                        <Route path="export-stats" element={<ExportStats />} />
                        <Route path="feed-scan" element={<FeedScan />} />
                        <Route path="plan" element={<UpgradeAccount />} />
                        <Route path="shows" element={<Shows />} />
                        <Route path="survey" element={<Survey />} />
                        <Route path="users/*">
                            <Route index element={<Users />} />
                        </Route>
                        <Route path="youtube" element={<YouTubeChannels />} />
                    </Route>
                    <Route path="rankings" element={<Rankings />} />
                    <Route path="upgrade" element={<Upgrade />} />
                    <Route path="shows/:showID/*">
                        <Route index element={<ShowDetails />} />
                        <Route path="audience" element={<Audience />} />
                        <Route path="demographics" element={<Demographics />} />
                        <Route path="downloads/*" element={<Downloads />}>
                            <Route path="" element={<MeasurementReport />} />
                            <Route
                                path="compare-episodes"
                                element={<EpisodeComparison />}
                            />
                            <Route
                                path=":report"
                                element={<MeasurementReport />}
                            />
                            <Route
                                path=":report/:period/:reportStart/:reportEnd"
                                element={<MeasurementReport />}
                            />
                        </Route>
                        <Route path="rankings/*" element={<ShowRankingsRoutes />} />
                        <Route
                            path="links/*"
                            element={<LinksRoutes />}
                        />
                        <Route
                            path="settings/*"
                            element={<ShowSettingsLayout />}
                        >
                            <Route index element={<ShowInfo />} />
                            <Route path="feeds" element={<FeedSettings />} />
                            <Route
                                path="feed-services"
                                element={<FeedMirror />}
                            />
                            <Route
                                path="measurement"
                                element={<MeasurementSettings />}
                            />
                            <Route
                                path="youtube"
                                element={<YouTubeShowSettings />}
                            />
                        </Route>
                    </Route>
                    <Route path="help" element={<Help />} />
                    <Route path="office-hours" element={<OfficeHours />} />
                </Route>
                <Route path="profile" element={<EditProfile />} />
                <Route path="*" element={<Sad />} />
            </Route>
        </Routes>
    ) : isError ? (
        <Error error={error} />
    ) : (
        <Loading />
    );
}

export const Component = Dashboard;
